import { useMutation, useQueryClient } from '@tanstack/react-query';
import { retryDestinationPushRequest, revertDestinationPushRequest } from '_/api/destinationPushes/destinationPushes.api';
import { notification } from 'antd';

/**
 * Hook to retry a destination push
 */
export const useRetryDestinationPush = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (destinationPushId: string) => retryDestinationPushRequest(destinationPushId),
    onSuccess: () => {
      // Invalidate all delivery destination pushes queries
      void queryClient.invalidateQueries({ queryKey: ['delivery-destination-pushes'] });
      // Invalidate all snapshot destination pushes queries
      void queryClient.invalidateQueries({ queryKey: ['snapshot-destination-pushes'] });

      notification.success({
        message: 'Destination Push retried',
      });
    },
    onError: (error: any) => {
      console.error('Error retrying destination push', error);
      notification.error({
        message: error.messages?.[0] || 'Error retrying destination push',
      });
    },
  });
};

/**
 * Hook to revert a destination push
 */
export const useRevertDestinationPush = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (destinationPushId: string) => revertDestinationPushRequest(destinationPushId),
    onSuccess: () => {
      // Invalidate all delivery destination pushes queries
      void queryClient.invalidateQueries({ queryKey: ['delivery-destination-pushes'] });
      // Invalidate all snapshot destination pushes queries
      void queryClient.invalidateQueries({ queryKey: ['snapshot-destination-pushes'] });

      notification.success({
        message: 'Destination Push reverted',
      });
    },
    onError: (error: any) => {
      console.error('Error reverting destination push', error);
      notification.error({
        message: error.messages?.[0] || 'Error reverting destination push',
      });
    },
  });
};
